export class UserRoleProvider {
  appIdentifier!: string;
  businessRoles!: string[];
  appRegistrationRoles: string[] = [];
}
